export default "__VITE_ASSET__UMLA1iEP__"